import { render } from "./QwLinkButton.vue?vue&type=template&id=39fa685c"
import script from "./QwLinkButton.vue?vue&type=script&lang=js"
export * from "./QwLinkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__